<template>
    <div class="selected-embryo">
        <patient-share-video
            :well="selectedEmbryo"
            :selected-day="selectedDay"
            :latest-day="latestDay"
            @selectDay="setDay"
        />

        <div class="days-section">
            <days :selected-idx="selectedDay" :latest-day="latestDay" @daySelected="setDay" />

            <day-description :selected-idx="selectedDay" :latest-day="latestDay" />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import Days from './Days'
import DayDescription from './DayDescription'
import PatientShareVideo from './PatientShareVideo'

export default {
    name: 'SelectedEmbryo',
    components: { Days, DayDescription, PatientShareVideo },
    data: () => ({
        selectedDay: 1
    }),
    computed: {
        ...mapState({
            treatment: state => state.patient.treatment,
            selectedEmbryoId: state => state.patient.selectedEmbryoId
        }),
        latestDay() {
            const { hoursSinceFertilization } = this.selectedEmbryo.slide

            const HOURS_IN_DAY = 24
            const MAX_DAY_COUNT = 5

            const dayCount = Math.ceil(hoursSinceFertilization / HOURS_IN_DAY)

            return dayCount > MAX_DAY_COUNT ? MAX_DAY_COUNT : dayCount
        },
        selectedEmbryo() {
            return this.treatment.wells.find(embryo => embryo._id === this.selectedEmbryoId)
        }
    },
    methods: {
        setDay(dayCount) {
            this.selectedDay = dayCount
        }
    }
}
</script>

<style lang="scss" scoped>
.selected-embryo {
    position: relative;

    .patient-share-video {
        width: 100%;
    }

    .days-section {
        padding: 10px;

        .day-description {
            margin-top: 15px;
        }
    }
}
</style>
